import React from "react";
import {
  FareCardBase,
  FareCardBaseContent,
  FareCardBaseProps
} from "../FareCardBase";
import Skeleton from "react-loading-skeleton";
import { FareCardHeader } from "../FareCardHeader/FareCardHeader";
import { FareCardFooter } from "../FareCardFooter/FareCardFooter";
import {
  FareInfographicSkeleton,
  FareInfographicSkeletonProps
} from "../../FareInfographic/FareInfographicSkeleton";

type FareCardSkeletonProps = Omit<FareCardBaseProps, "trackingName"> &
  FareInfographicSkeletonProps;

export const FareCardSkeleton: React.FC<FareCardSkeletonProps> = ({
  expandable,
  variant,
  isExpanded,
  ...cardProps
}) => {
  return (
    <FareCardBase {...cardProps} trackingName="">
      <FareCardHeader title={<Skeleton count={1} width="150px" />}>
        <Skeleton count={1} width="150px" />
      </FareCardHeader>
      <FareCardBaseContent>
        <FareInfographicSkeleton
          isExpanded={isExpanded}
          expandable={expandable}
          variant={variant}
        />
      </FareCardBaseContent>
      <FareCardFooter></FareCardFooter>
    </FareCardBase>
  );
};
